import { Truck, TruckManualModeStage } from '@numeo/types-core'

const WARNING_MANUAL_MODE_STAGES: TruckManualModeStage[] = [TruckManualModeStage.DAY7, TruckManualModeStage.DAY14, TruckManualModeStage.DAY30]

interface TruckWithEldLink {
    eldIntegration?: { vehicleId?: string; integrationId?: string; type?: string } | null
}

export function hasConnectedEld(truck?: TruckWithEldLink | null): boolean {
    return Boolean(truck?.eldIntegration?.vehicleId && (truck.eldIntegration.integrationId || truck.eldIntegration.type))
}

/** No ELD link of any kind, not even a half-made one: the backend places only such a truck by a driver's phone (ADR-059). */
export function hasNoEldLink(truck?: TruckWithEldLink | null): boolean {
    return !truck?.eldIntegration?.type && !truck?.eldIntegration?.integrationId && !truck?.eldIntegration?.vehicleId
}

export function getTruckManualModeStage(truck: Truck): TruckManualModeStage | null {
    const stage = truck.manualModeTracking?.stage
    if (!stage || stage === TruckManualModeStage.NONE || stage === TruckManualModeStage.RESOLVED) {
        return null
    }
    return stage
}

export function isWarningManualModeStage(stage: TruckManualModeStage | null): boolean {
    return Boolean(stage && WARNING_MANUAL_MODE_STAGES.includes(stage))
}

export function getManualModeStageLabel(stage: TruckManualModeStage): string {
    switch (stage) {
        case TruckManualModeStage.DAY3:
            return 'Reminder'
        case TruckManualModeStage.DAY7:
            return 'Warning'
        case TruckManualModeStage.DAY14:
            return 'Strong Warning'
        case TruckManualModeStage.DAY30:
            return 'Escalation'
        default:
            return 'Manual Mode'
    }
}

export function getManualModeStageColor(stage: TruckManualModeStage): 'warning' | 'danger' {
    if (stage === TruckManualModeStage.DAY14 || stage === TruckManualModeStage.DAY30) {
        return 'danger'
    }
    return 'warning'
}

export function getManualModeStageMessage(stage: TruckManualModeStage, daysInManualMode: number): string {
    switch (stage) {
        case TruckManualModeStage.DAY3:
            return 'Truck is being managed manually. Connect ELD to automate tracking.'
        case TruckManualModeStage.DAY7:
            return 'Truck used manually for 7 days. Connect ELD to avoid missed or inaccurate updates.'
        case TruckManualModeStage.DAY14:
            return '14 days without ELD detected. Manual tracking may cause data issues. Connect ELD.'
        case TruckManualModeStage.DAY30:
            return '30 days without ELD. Connect ELD to enable automatic tracking and location updates.'
        default:
            return `Truck is in manual mode for ${daysInManualMode} days. Connect ELD.`
    }
}
